import { useCallback, useMemo } from 'react'

import { Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import { observer } from 'mobx-react-lite'
import { State } from 'types/graphql'

import { StateAbbreviationMap, StateNameMap } from 'src/constants/states'

const stateOptions: SelectOption<State>[] = Object.keys(StateAbbreviationMap).map((state) => ({
  label: StateNameMap[state as State],
  value: state as State,
}))

const filterStateOption = (searchQuery: string, option: SelectOption<State>): boolean => {
  const query = searchQuery.toLowerCase()
  const stateName = option.label.toLowerCase()
  const stateAbbreviation = StateAbbreviationMap[option.value].toLowerCase()
  return stateName.includes(query) || stateAbbreviation.startsWith(query)
}

type Props = {
  errorMessage?: string
  isClearable?: boolean
  isInvalid?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onValueChange: (value: State | null | undefined) => void
  placeholder?: string
  value: State | null | undefined
  width?: React.CSSProperties['width']
}
const StaffUserSelect = ({
  errorMessage,
  isClearable,
  isInvalid,
  isRequired,
  label,
  onBlur,
  onValueChange,
  placeholder,
  value,
  width,
}: Props) => {
  const selectedOption = useMemo(() => {
    return stateOptions.find((o) => o.value === value)
  }, [value])

  const handleSelectedOptionChange = useCallback(
    (newSelectedOption: SelectOption<State> | undefined) => {
      onValueChange(newSelectedOption?.value)
    },
    [onValueChange]
  )

  const getOptionKey = useCallback((option: SelectOption<State>) => option.value, [])

  return (
    <Select
      {...(label ? { label } : { ariaLabel: 'State' })}
      errorMessage={errorMessage}
      filterOption={filterStateOption}
      getOptionKey={getOptionKey}
      isClearable={isClearable}
      isInvalid={isInvalid}
      isRequired={isRequired}
      onBlur={onBlur}
      onSelectedOptionChange={handleSelectedOptionChange}
      options={stateOptions}
      placeholder={placeholder}
      selectedOption={selectedOption}
      width={width}
    />
  )
}

export default observer(StaffUserSelect)
